import type { State } from "@store/reducers";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";
import type {
  NewReferralsTrackerItem,
  NewReferralStats,
  ActiveReferralStats,
  ActiveReferralsTrackerItem,
  ClosedReferralsTrackerItem,
  SupplierReferralDetails,
  ReferralRTWDetails,
  ReferralLogDetails,
  ReferralStatusDetails,
  CommonData,
  OutcomesReport,
  ManagerKpiReport,
} from "@modules/reporting/reducer/referral-tracker/types";

export const isLoading = (state: State): boolean =>
  state.reporting.referralTracker.requestsInProgress > 0;

export const selectNewReferrals = (state: State): NewReferralsTrackerItem[] => {
  return state.reporting.referralTracker.newReferrals.supplierReferralTasks.content;
};

export const selectNewReferralsPagination = (state: State): PaginationExtendedType => {
  return getPagination(state.reporting.referralTracker.newReferrals.supplierReferralTasks);
};

export const selectNewReferralsStats = (state: State): NewReferralStats => {
  const {
    newReferrals,
    employeeLedReferrals,
    managerLedReferrals,
    manualReferrals,
    overdueReferrals,
  } = state.reporting.referralTracker.newReferrals;
  return {
    newReferrals,
    employeeLedReferrals,
    managerLedReferrals,
    manualReferrals,
    overdueReferrals,
  };
};

export const selectActiveReferralsStats = (state: State): ActiveReferralStats => {
  const {
    currentActiveReferrals,
    referralsLessThanSevenDaysOld,
    referralsLessThanThirtyDaysOld,
    referralsLessThanNinetyDaysOld,
    referralsOlderThenNinetyDays,
  } = state.reporting.referralTracker.activeReferrals;
  return {
    currentActiveReferrals,
    referralsLessThanSevenDaysOld,
    referralsLessThanThirtyDaysOld,
    referralsLessThanNinetyDaysOld,
    referralsOlderThenNinetyDays,
  };
};

export const selectActiveReferrals = (state: State): ActiveReferralsTrackerItem[] => {
  return state.reporting.referralTracker.activeReferrals.supplierReferralTasks.content;
};

export const selectActiveReferralsPagination = (state: State): PaginationExtendedType => {
  return getPagination(state.reporting.referralTracker.activeReferrals.supplierReferralTasks);
};

export const selectClosedReferrals = (state: State): ClosedReferralsTrackerItem[] => {
  return state.reporting.referralTracker.closedReferrals.supplierReferralTasks.content;
};

export const selectClosedReferralsPagination = (state: State): PaginationExtendedType => {
  return getPagination(state.reporting.referralTracker.closedReferrals.supplierReferralTasks);
};

export const selectedReferralDetails = (state: State): SupplierReferralDetails => {
  return state.reporting.referralTracker.referralDetails;
};

export const showReferralDetailsModal = (state: State): boolean => {
  return state.reporting.referralTracker.modals.showReferralDetails;
};
//RTW
export const showRTWReferralDetailsModal = (state: State): boolean => {
  return state.reporting.referralTracker.modals.showRTWReferralDetails;
};

export const selectedRTWReferralDetails = (state: State): ReferralRTWDetails => {
  return state.reporting.referralTracker.referralRTWDetails;
};
//Log
export const showLogReferralDetailsModal = (state: State): boolean => {
  return state.reporting.referralTracker.modals.showLogReferralDetails;
};
export const selectedLogReferralDetails = (state: State): Array<ReferralLogDetails> => {
  return state.reporting.referralTracker.referralLogDetails;
};
//Status
export const showStatusReferralDetailsModal = (state: State): boolean => {
  return state.reporting.referralTracker.modals.showStatusReferralDetails;
};

export const selectedStatusReferralDetails = (state: State): ReferralStatusDetails => {
  return state.reporting.referralTracker.referralStatusDetails;
};
export const selectReferralCommonData = (state: State): CommonData => {
  return state.reporting.referralTracker.commonData;
};

export const selectClosedReferralsStatuses = (state: State): Array<string> => {
  return state.reporting.referralTracker.closedReferralsStatuses;
};

export const selectOutcomesReport = (state: State): OutcomesReport[] => {
  return state.reporting.referralTracker.outcomesReport;
};

export const selectManagerKpiReport = (state: State): ManagerKpiReport[] => {
  return state.reporting.referralTracker.managerKpiReports.content;
};

export const selectManagerKpiReportPagination = (state: State): PaginationExtendedType => {
  const managerKpi = state.reporting.referralTracker.managerKpiReports;

  return {
    ...managerKpi.pagination,
    totalPages: Math.ceil(managerKpi.totalElements / managerKpi.pagination.pageSize) || 0,
  };
};
